import { Plugin } from 'ckeditor5/src/core';

import { Widget, toWidget, viewToModelPositionOutsideModelElement } from 'ckeditor5/src/widget';

// import { viewToModelPositionOutsideModelElement } from '@ckeditor/ckeditor5-widget/src/utils';
import RocLinkCommand from './roclinkcommand';
import '../theme/roclink.css';

export default class RocLinkEditing extends Plugin {
	static get requires() {
		return [Widget];
	}

	static get pluginName() {
		return 'RocLinkEditing';
	}

	init() {
		this._defineSchema();
		this._defineConverters();

		this.editor.commands.add('rocLink', new RocLinkCommand(this.editor));
		this.editor.editing.mapper.on(
			'viewToModelPosition',
			viewToModelPositionOutsideModelElement(this.editor.model, (viewElement) =>
				viewElement.hasClass('placeholder'),
			),
		);
	}

	_defineSchema() {
		const schema = this.editor.model.schema;

		schema.register('roclink', {
			// Allow wherever text is allowed:
			allowWhere: '$text',

			// The placeholder will act as an inline node:
			isInline: true,

			// The inline widget is self-contained so it cannot be split by the caret and can be selected:
			isObject: true,

			// The inline widget can have the same attributes as text (for example linkHref, bold).
			allowAttributesOf: '$text',

			// The placeholder can have many types, like date, name, surname, etc:
			allowAttributes: ['name'],
		});
	}

	_defineConverters() {
		// ADDED
		const conversion = this.editor.conversion;

		conversion.for('upcast').elementToElement({
			view: {
				name: 'span',
				classes: ['roclink'],
			},
			model: (viewElement, { writer: modelWriter }) => {
				// Extract the "name" from "{name}".
				const name = viewElement.getChild(0).data.slice(1, -1);

				return modelWriter.createElement('roclink', { name });
			},
		});

		conversion.for('editingDowncast').elementToElement({
			model: 'roclink',
			view: (modelItem, { writer: viewWriter }) => {
				const widgetElement = createRocLinkView(modelItem, viewWriter);

				// Enable widget handling on a placeholder element inside the editing view.
				return toWidget(widgetElement, viewWriter);
			},
		});

		conversion.for('dataDowncast').elementToElement({
			model: 'roclink',
			view: (modelItem, { writer: viewWriter }) => createRocLinkView(modelItem, viewWriter),
		});

		// Helper method for both downcast converters.
		function createRocLinkView(modelItem, viewWriter) {
			const name = modelItem.getAttribute('name');

			const placeholderView = viewWriter.createContainerElement('span', {
				class: 'roclink',
			});
			// Insert the placeholder name (as a text).
			const innerText = viewWriter.createText('{' + name + '}');
			viewWriter.insert(viewWriter.createPositionAt(placeholderView, 0), innerText);

			return placeholderView;
		}
	}
}
